export const PRIMARY_FONT_FAMILY = 'IBM Plex Sans, sans-serif';
